import { Box } from "@mui/material"
import React from "react"

// portfolio about-page contact buttons — LinkedIn primary (accent fill),
// rest tonal. Glyphs from the portfolio (simple-icons) plus the favicon fox
// mark (potrace coords — needs the y-flip transform)
const LINKS = [
    {
        href: "https://www.linkedin.com/in/wisl/",
        // accessible name matches the contacts' same-href links (axe
        // identical-links-same-purpose)
        label: "LinkedIn",
        name: "LinkedIn (/wisl)",
        variant: "primary",
        tf: undefined,
        vb: "0 0 24 24",
        d: "M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.21 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z",
    },
    {
        href: "https://github.com/wislertt",
        label: "GitHub",
        name: "GitHub (/wislertt)",
        variant: "tonal",
        tf: undefined,
        vb: "0 0 24 24",
        d: "M12 .297c-6.63 0-12 5.373-12 12 0 5.303 3.438 9.8 8.205 11.385.6.113.82-.258.82-.577 0-.285-.01-1.04-.015-2.04-3.338.724-4.042-1.61-4.042-1.61C4.422 18.07 3.633 17.7 3.633 17.7c-1.087-.744.084-.729.084-.729 1.205.084 1.838 1.236 1.838 1.236 1.07 1.835 2.809 1.305 3.495.998.108-.776.417-1.305.76-1.605-2.665-.3-5.466-1.332-5.466-5.93 0-1.31.465-2.38 1.235-3.22-.135-.303-.54-1.523.105-3.176 0 0 1.005-.322 3.3 1.23.96-.267 1.98-.399 3-.405 1.02.006 2.04.138 3 .405 2.28-1.552 3.285-1.23 3.285-1.23.645 1.653.24 2.873.12 3.176.765.84 1.23 1.91 1.23 3.22 0 4.61-2.805 5.625-5.475 5.92.42.36.81 1.096.81 2.22 0 1.606-.015 2.896-.015 3.286 0 .315.21.69.825.57C20.565 22.092 24 17.592 24 12.297c0-6.627-5.373-12-12-12",
    },
    {
        href: "https://wisl.medium.com",
        label: "Medium",
        name: "Medium",
        variant: "tonal",
        tf: undefined,
        vb: "0 0 448 512",
        d: "M369.4 32c43.4 0 78.6 35.2 78.6 78.6l0 83.8c-1.9-.1-3.8-.2-5.7-.2l-.4 0c-10 0-22.3 2.4-31.1 6.8-10 4.6-18.7 11.5-26 20.6-11.8 14.6-18.9 34.3-20.6 56.4-.1 .7-.1 1.3-.2 2s-.1 1.2-.1 1.9c-.1 1.2-.1 2.4-.1 3.6 0 1.9-.1 3.8 0 5.8 1.2 50.1 28.2 90.2 76.3 90.2 2.7 0 5.3-.1 7.9-.4l0 20.4c0 43.4-35.2 78.6-78.6 78.6L78.6 480C35.2 480 0 444.8 0 401.4L0 110.6C0 67.2 35.2 32 78.6 32l290.8 0zM82.3 138.9l.3 .1c13.2 3 19.8 7.4 19.8 23.4l0 187.2c0 16-6.7 20.4-19.9 23.4l-.3 .1 0 2.8 52.8 0 0-2.8-.3-.1c-13.2-3-19.9-7.4-19.9-23.4l0-176.3 86.1 202.5 4.9 0 88.6-208.2 0 186.6c-1.1 12.6-7.8 16.5-19.7 19.2l-.3 .1 0 2.7 91.9 0 0-2.7-.3-.1c-11.9-2.7-18.7-6.6-19.9-19.2l-.1-191.8 .1 0c0-16 6.7-20.4 19.9-23.4l.3-.1 0-2.7-72.2 0-67 157.4-67-157.4-77.8 0 0 2.7zM448 340.3c-25.1-7.4-43-35.1-41.2-67.8l0 0 41.1 0 0 67.8zm-6.4-135.6c2.3 0 4.4 .3 6.4 .9l0 57.4-40.2 0c1.5-33.6 13.6-57.9 33.8-58.3z",
    },
    {
        // the personal fox mark (favicon), plain glyph on currentColor
        href: "https://wisl.dev/",
        // the plain domain is both visible label and accessible name — axe
        // wants one name per href, with the visible text inside it
        label: "wisl.dev",
        name: "wisl.dev",
        variant: "tonal",
        vb: "0 0 702 682",
        tf: "translate(0,682) scale(0.1,-0.1)",
        d: "M1003 6804 c-132 -65 -256 -359 -328 -775 -64 -373 -67 -783 -9 -1244 16 -130 82 -469 112 -577 l19 -67 -74 -88 c-366 -439 -605 -957 -687 -1488 -26 -166 -37 -396 -27 -543 4 -73 11 -135 14 -138 2 -3 36 18 73 47 38 29 101 67 139 85 122 57 110 73 110 -149 1 -208 14 -305 61 -447 80 -240 209 -444 396 -626 77 -76 222 -194 237 -194 4 0 12 30 18 67 13 83 43 163 84 228 l32 50 55 -65 c91 -106 257 -265 355 -339 395 -296 791 -445 1392 -523 97 -13 767 -19 778 -8 3 3 0 52 -6 110 -13 132 2 318 37 444 76 274 246 479 490 591 237 110 494 149 1135 175 416 17 560 39 748 115 244 98 498 299 704 555 171 213 198 340 96 446 -34 35 -71 55 -197 109 -849 363 -1052 451 -1095 473 -88 44 -193 122 -265 199 -115 120 -156 193 -256 455 -122 317 -215 478 -374 642 -194 201 -436 354 -800 505 -293 121 -585 191 -915 222 -66 6 -125 16 -131 22 -6 7 -92 104 -190 217 -428 489 -1100 1191 -1294 1351 -81 68 -178 130 -240 156 -65 27 -150 30 -197 7z m3292 -3409 c91 -19 168 -58 229 -114 65 -61 266 -307 266 -326 0 -23 -31 -18 -111 18 l-74 32 -190 1 c-164 1 -199 4 -255 22 -89 29 -181 85 -258 157 -66 60 -142 150 -142 165 0 19 249 57 380 59 47 0 116 -6 155 -14z m-754 -1015 c357 -28 726 -103 1224 -250 271 -80 404 -114 575 -149 387 -80 738 -90 1034 -30 54 11 100 18 103 16 5 -6 -86 -88 -152 -138 -112 -84 -295 -162 -459 -195 -39 -7 -183 -18 -321 -24 -137 -6 -353 -15 -480 -20 -430 -18 -702 -71 -942 -185 -383 -181 -610 -526 -655 -996 l-12 -127 -41 5 c-201 23 -336 60 -491 132 -298 140 -502 402 -554 712 -14 78 -9 78 -137 19 -96 -45 -150 -81 -228 -152 l-57 -52 5 164 c4 120 10 184 25 235 76 273 235 463 512 614 l73 39 -40 20 c-70 36 -161 54 -270 54 -57 0 -103 1 -103 2 0 9 137 91 210 127 173 85 444 157 665 177 142 13 359 14 516 2z M3770 6617 c-78 -33 -123 -64 -225 -155 -131 -116 -292 -298 -477 -537 -93 -121 -288 -392 -288 -401 0 -3 54 -68 121 -144 133 -154 110 -140 264 -155 255 -26 573 -107 847 -216 54 -21 103 -39 110 -39 19 0 -3 697 -33 1020 -19 214 -59 426 -100 534 -40 107 -113 138 -219 93z",
    },
] as const

export const SocialRow: React.FC = () => (
    <Box sx={{ display: "flex", flexDirection: "column", gap: "12px", width: 250 }}>
        {LINKS.map((s) => {
            const primary = s.variant === "primary"
            return (
                <Box
                    key={s.label}
                    component="a"
                    href={s.href}
                    target="_blank"
                    rel="noopener"
                    aria-label={s.name}
                    sx={{
                        display: "inline-flex",
                        alignItems: "center",
                        gap: "8px",
                        height: 42,
                        padding: "0 22px",
                        borderRadius: "8px",
                        fontSize: 15,
                        fontWeight: 500,
                        textDecoration: "none",
                        transition: "transform 0.15s ease, border-color 0.15s ease",
                        ...(primary
                            ? {
                                  backgroundColor: "primary.main",
                                  color: "primary.contrastText",
                                  "&:hover": { transform: "translateY(-1px)" },
                              }
                            : {
                                  backgroundColor: "background.default",
                                  color: "text.primary",
                                  border: "1px solid",
                                  borderColor: "divider",
                                  "&:hover": { borderColor: "text.disabled" },
                              }),
                    }}
                >
                    <Box
                        component="svg"
                        viewBox={s.vb}
                        aria-hidden="true"
                        sx={{ width: "auto", height: 20, display: "block" }}
                    >
                        <path fill="currentColor" transform={s.tf} d={s.d} />
                    </Box>
                    {s.label}
                </Box>
            )
        })}
    </Box>
)
